<template>
  <span
    class="whats_app_wrapper">
    <v-tooltip
      bottom>
      <template
        v-slot:activator="{ on }"
      >
        <span
          v-on="on">
          <v-btn
            @click="send_whatsapp"
            large
            class="btn_submit"
            color="green"
            icon>
            <img
              class="whats_app_logo"
              :src="whats_app_icon"
              alt="">
          </v-btn>
        </span>
      </template>
      <span
        v-html="'¡Contáctanos!'"
      />
    </v-tooltip>
  </span>
</template>
<script>
export default {
  data: () => ({
    whats_app_icon: '/img/static/whatsapp.svg'
  }),
  methods: {
    send_whatsapp () {
      window.open('https://wa.me/52' + this.phone_number)
    }
  },
  props: {
    phone_number: String
  }
}
</script>
<style scoped>
.whats_app_logo {
  max-width: 65%
}
.whats_app_wrapper {
  -webkit-box-shadow: 14px 11px 35px -3px rgba(0,0,0,0.75);
  -moz-box-shadow: 14px 11px 35px -3px rgba(0,0,0,0.75);
  box-shadow: 14px 11px 35px -3px rgba(0,0,0,0.75);
  border-radius: 100%;
  background-color: #4CAF50;
  z-index: 12;
  padding: 8px;
  position: fixed;
  bottom: 0;
  right: 0;
  margin-right: 3%;
  margin-bottom: 4%;
}
</style>